export const DUPLICATE_HOTEL_NAME_MESSAGE = 'A hotel with this name already exists in this city';

export interface HotelNameCityRecord {
  hotel_name: string;
  city_id: number;
}

export const hotelNameExistsInCity = (
  hotels: HotelNameCityRecord[],
  hotelName: string,
  cityId: number,
): boolean => {
  const normalizedHotelName = hotelName.trim().toLowerCase();

  if (!normalizedHotelName || !cityId) {
    return false;
  }

  return hotels.some(
    (hotel) =>
      hotel.city_id === cityId &&
      hotel.hotel_name.trim().toLowerCase() === normalizedHotelName,
  );
};
